"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumValueToKey = void 0;
// From https://stackoverflow.com/a/54297863
function enumValueToKey(myEnum, enumValue) {
    var keys = Object.keys(myEnum).filter(function (x) { return myEnum[x] === enumValue; });
    return keys.length > 0 ? keys[0] : null;
}
exports.enumValueToKey = enumValueToKey;
